var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container-item-wrapper', {
    attrs: {
      "widget": _vm.widget
    }
  }, [_c('el-container', [_c('el-main', {
    staticStyle: {
      "align-items": "baseline"
    }
  }, [(_vm.widget.options.filter) ? _c('el-input', {
    attrs: {
      "size": _vm.widget.options.size,
      "placeholder": _vm.i18nt('designer.setting.enterForQuery')
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-button-group', [(_vm.widget.options.expandRetractAllNode) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "round": "",
      "plain": "",
      "size": _vm.widget.options.size
    },
    on: {
      "click": function($event) {
        return _vm.expandAllNodes()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.i18nt('designer.setting.expandRetractAllNode')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.widget.options.selectClearAllNode && _vm.widget.options.showCheckBox) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "round": "",
      "plain": "",
      "size": _vm.widget.options.size
    },
    on: {
      "click": function($event) {
        return _vm.checkAllNodes()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.i18nt('designer.setting.selectClearAllNode')) + "\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('el-tree', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingFlag),
      expression: "loadingFlag"
    }],
    ref: "tree",
    attrs: {
      "data": _vm.widget.options.treeData,
      "props": _vm.defaultProps,
      "border": "",
      "lazy": _vm.widget.options.lazy,
      "node-key": "id",
      "highlight-current": "",
      "current-node-key": _vm.currentKey,
      "show-checkbox": _vm.widget.options.showCheckBox,
      "expand-on-click-node": _vm.widget.options.expandOnClickNode,
      "default-expand-all": _vm.widget.options.defaultExpandAllNode,
      "draggable": _vm.widget.options.draggable,
      "check-strictly": _vm.widget.options.checkStrictly,
      "filter-node-method": _vm.filterNode
    },
    on: {
      "node-click": _vm.handleTreeNodeClick,
      "node-contextmenu": _vm.handleTreeNodeContextmenu,
      "check": _vm.handleTreeNodeCheck,
      "check-change": _vm.handleCheckChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('span', {
          staticClass: "custom-tree-node"
        }, [_c('span', [_vm._v(_vm._s(node.label))]), _vm._v(" "), (_vm.widget.options.nodeEdit) ? _c('span', [_c('el-button', {
          attrs: {
            "type": "text",
            "size": _vm.widget.options.size
          },
          on: {
            "click": function($event) {
              return _vm.append(data)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.i18nt('designer.setting.add')) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": _vm.widget.options.size
          },
          on: {
            "click": function($event) {
              return _vm.remove(node, data)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.i18nt('designer.setting.delete')) + "\n\t\t\t\t\t\t\t")])], 1) : _vm._e()])
      }
    }])
  })], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1418f24f","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-render/container-item/tree-item.vue
// module id = null
// module chunks = 